import { effect, Injectable, signal } from '@angular/core';
import { DateTime } from 'luxon';

export type SelectsData = {
  project: string | null;
  type: string | null;
  service: string | null;
  boxId: string | null;
  folderId: string | null;
  message: string | null;
  dateStart: Date | string | null;
  dateEnd: Date | string | null;
};

@Injectable({
  providedIn: 'root',
})
export class SelectsService {
  public readonly DEFAULT_DAYS_BACK = 5;

  public fieldsValue = signal<Partial<SelectsData>>(this.getInitialData());

  constructor() {
    effect(() => {
      localStorage.setItem('selectsData', JSON.stringify(this.fieldsValue()))
    }
    );
  }

  getInitialData(): Partial<SelectsData> {
    const savedData = localStorage.getItem('selectsData');

    if (savedData) {
      const parsedData = JSON.parse(savedData);
      // Convert date strings back to Date objects
      if (parsedData.dateStart) {
        parsedData.dateStart = new Date(parsedData.dateStart);
      }
      if (parsedData.dateEnd) {
        parsedData.dateEnd = new Date(parsedData.dateEnd);
      }
      return parsedData;
    }
    else {
      return {
        project: '',
        service: '',
        type: '',
        boxId: '',
        folderId: '',
        message: '',
        dateStart: DateTime.utc().minus({ days: this.DEFAULT_DAYS_BACK }).toJSDate(),
        dateEnd: DateTime.utc().toJSDate(),
      }
    }
  }
}
